module.exports = __webpack_public_path__ + "img/arrow_up_s.e3489ebc.svg";